<template>
    <div>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div aria-controls="filterForm" class="card-title collapsed"
                         data-target="#filterForm"
                         data-toggle="collapse">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <kt-panel>
                    <div aria-labelledby="filterForm" class="collapse" data-parent="#userFilter" id="filterForm">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="type"
                                                   v-text="$t('label.type')"
                                            >
                                            </label>
                                            <select id="type" class="form-control" name="type" v-model="query.type"
                                            >
                                                <option :value="null" selected v-text="$t('label.all_types')"
                                                ></option>
                                                <option :value="transmitType.debit"
                                                        v-text="transmitTypeStr.get(transmitType.debit)"
                                                ></option>
                                                <option :value="transmitType.credit"
                                                        v-text="transmitTypeStr.get(transmitType.credit)"
                                                ></option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="bank_account"
                                                   v-text="$t('label.bank_account')"
                                            >
                                            </label>
                                            <select class="form-control kt-selectpicker" id="bank_account" name="bank_account"
                                                    v-model="query.bank_account">
                                                <option :value="null" selected v-text="$t('label.default')"
                                                ></option>
                                                <option :key="index" :value="account.number"
                                                        v-for="(account, index) in keshavarzi_banks"
                                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                                >
                                                </option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="description"
                                                   v-text="$t('label.description')"
                                            >
                                            </label>
                                            <input id="description"
                                                   type="text"
                                                   class="form-control"
                                                   name="description"
                                                   v-model="query.description"
                                            >
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="from_date"
                                                   v-text="$t('label.from_date')"
                                            >
                                            </label>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "query.from_date"
                                                    v-model="query.from_date"
                                                    type="datetime" />
                                        </kt-col>
                                        <kt-col class="mb-2" md="3" sm="3" xs="12">
                                            <label for="to_date"
                                                   v-text="$t('label.to_date')"
                                            >
                                            </label>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "query.to_date"
                                                    v-model="query.to_date"
                                                    type="datetime" />
                                        </kt-col>
                                    </kt-form-row>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" class="mt-4">
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                    <div class="line-divider my-3"></div>
                    <kt-panel-body>
                        <kt-datatable ref="datatable" v-bind="datatableProps">
                        </kt-datatable>
                    </kt-panel-body>
                </kt-panel>
            </div>
        </div>
    </div>
</template>

<script>
    import {ApiUrl, walletService} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import keshavarziColumn from "./columns/keshavarzi-columns";
    import {transmitDescription, transmitDescriptionStr} from '@/constants/transmitDescription';
    import {transmitType, transmitTypeStr} from "@/constants/transmitType";
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";

    export default {
        props: {
            fetch_starshop: {
                default: false,
                type: Boolean
            },
            api_base_path: {
                default: ApiUrl.path(''),
                type: String
            },
        },
        data() {
            return {
                transmitType,
                transmitTypeStr,
                transmitDescription,
                transmitDescriptionStr,
                keshavarzi_banks: [],
                query: {
                    type: null,
                    description: '',
                    bank_account: null,
                },
            };
        },
        mounted() {
            const keshavarziBanks = this.fetch_starshop
                ? walletService.getStarShopAllWalletKeshavarziBanks
                : walletService.getAllWalletKeshavarziBanks;

            keshavarziBanks().then(res => {
                this.keshavarzi_banks = res.data.data.all_keshavarzi_bank_accounts;
                this.initSelectPicker();
            });
        },
        methods: {
            initSelectPicker() {
                setTimeout(() => {
                    $('.kt-selectpicker').selectpicker({
                        size: 4,
                        liveSearch: true,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_selected')
                    })
                }, 1000);
            },
            filterAction(e, query) {
                if (this.query.from_date != null && this.query.to_date == null) {
                    alert(i18n.t('wallets.error.when_from_date_is_filled_to_date_should_be_filled'));

                    return;
                }

                if (this.query.from_date == null && this.query.to_date != null) {
                    alert(i18n.t('wallets.error.when_to_date_is_filled_from_date_should_be_filled'));

                    return;
                }

                if (this.query.from_date != null && this.query.to_date != null) {
                    let day1 = this.query.from_date.substring(0, 10);
                    let day2 = this.query.to_date.substring(0, 10);

                    if (day1 !== day2) {
                        alert(i18n.t('wallets.error.from_date_and_to_date_should_be_at_same_day'));

                        return;
                    }
                }

                this.query = query;

                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
        },
        computed: {
            datatableProps() {
                return {
                    id: 'keshavarzi_statement_report_datatable',
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: this.api_base_path + 'wallet/common/admin/get-keshavarzi-statements',
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: res => {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: keshavarziColumn,
                }
            },
        },
    }
</script>
